import { Component, inject, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

import { AppointmentBuilderComponent, AppointmentBuilderData } from '../appointment-builder/appointment-builder.component';

@Component({
    selector: 'app-schedule-toolbar',
    imports: [MatIconModule, MatButtonModule, MatToolbarModule],
    templateUrl: './schedule-toolbar.component.html',
    styleUrl: './schedule-toolbar.component.css'
})
export class ScheduleToolbarComponent {
  @Input() currentScheduleId?: string;
  @Input() selectedDate?: Date;
  @Input() selectedTime?: string;

  readonly dialog = inject(MatDialog);

  openAppointmentBuilder(): void {
    console.log('openAppointmentBuilder clicked');

    // Prepare data for the appointment builder
    const dialogData: AppointmentBuilderData = {};
    
    if (this.currentScheduleId) {
      dialogData.scheduleId = this.currentScheduleId;
    }
    
    if (this.selectedDate) {
      dialogData.initialDate = this.selectedDate.toISOString().split('T')[0];
    }
    
    if (this.selectedTime) {
      dialogData.initialTime = this.selectedTime;
    }

    const dialogRef = this.dialog.open(AppointmentBuilderComponent, {
      data: dialogData,
      width: '800px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Appointment created:', result);
        // Emit event to refresh scheduler or handle the new appointment
      }
    });
  }
}
